import React, { useEffect, useState } from 'react';
import { Button, MainContent, SubTitle } from "../../../../../components/StyledComponents";
import { Grid } from "@mui/material";
import Input from "../../../../../components/Input";
import { useApp } from "../../../../../context/app";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import Spinner from "react-spinner-material";
import styles from './styles.module.scss'
import { BaSeDialogContext, BaSeIcon } from "@base/react";
import { DiagnosticoService } from "../../../services/diagnosticoService";
import { handleModalStatus } from "../../../../../utils/handleModalStatus";
import { UserActionsContent } from "../../../../../components/UserActionsContent";
import TextAreaInput from "../../../../../components/TextAreaInput";
import EditorText from "../../../../../components/EditorText";

export const OrdernarPerguntas = () => {
    
    const {showModal} = React.useContext(BaSeDialogContext);
    const {manageItem, setManageItem, setRenderIncludeScreen} = useApp();
    const {diagnostico} = manageItem
    
    const [temaSelecionado, setTemaSelecionado] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [temas, setTemas] = useState([]);
    const [perguntas, setPerguntas] = useState([]);
    const [expanded, setExpanded] = React.useState([]);
    const [questionario, setQuestionario] = useState(null);
    
    const handleExpand = (index) => {
        setExpanded(prevState => {
            if (prevState.includes(index)) {
                return prevState.filter(item => item !== index);
            } else {
                return [...prevState, index];
            }
        });
    };
    
    useEffect(() => {
        setExpanded([]);
    }, [temaSelecionado])
    
    const handleGoHome = () => {
        setManageItem({})
        setRenderIncludeScreen(false);
    };
    
    
    const handleLabelLevel = (nome) => {
        const letter = nome.charAt(0);
        const COLOR_OPTION = {
            'B': '#CD5BE8',
            'I': '#666BFD',
            'A': '#0DBABA'
        }
        
        return (
            <div style={{
                backgroundColor: '#FFFFF',
                borderRadius: '32px',
                width: '32px',
                height: '32px',
                display: "flex",
                justifyContent: "center",
                alignContent: "center",
                alignItems: "center",
                fontWeight: "bold",
                color: COLOR_OPTION[letter],
                boxShadow: "2px 2px 4px rgba(84, 90, 174, 0.15)",
                marginRight: "8px"
            }}>
                {letter}
            </div>
        )
    }
    
    const handleUpdateDiagnostico = (data) => {
        
        DiagnosticoService.update(data)
            .then((response) => {
                handleModalStatus({
                    type: "success",
                    msgOnSuccess: "Diagnóstico foi editado com sucesso.",
                    onCloseModal: handleGoHome,
                    showModal,
                });
            })
            .catch((error) => {
                const errorMessage = error?.response?.data?.descricao
                if (errorMessage) {
                    handleModalStatus({
                        type: "error",
                        msgOnError: errorMessage,
                        showModal,
                    })
                    return;
                }
                handleModalStatus({
                    type: "error",
                    msgOnError:
                        "O Diagnóstico não foi editado. Aconteceu um erro ou o sistema está temporariamente fora do ar. Tente novamente mais tarde.",
                    showModal,
                })
            })
            .finally(() => {
            })
    };
    
    const save = () => {
        if (temaSelecionado) {
            const subTemasOrdenados = temaSelecionado.subTemas.map(subTema => {
                const perguntasOrdenadas = subTema.perguntas.map(p => {
                    const findOrder = perguntas.find(item => item.diagnosticoPerguntaID === p.diagnosticoPerguntaID && item.codSubtemaDiagnostico === subTema.codSubtemaDiagnostico)
                    p.ordenacao = findOrder.ordenacao;
                    return p
                })
                return {...subTema, perguntas: perguntasOrdenadas};
            });
            const temaToUpdate = temas.find(t => t.codAreaTematicaDiagnostico === temaSelecionado.codAreaTematicaDiagnostico);
            temaToUpdate.subTemas = subTemasOrdenados;
            setTemas([...temas.filter(t => t.codAreaTematicaDiagnostico !== temaToUpdate.codAreaTematicaDiagnostico), temaToUpdate].sort((a,
                b) => a.ordenacaoTema - b.ordenacaoTema));
            setTemaSelecionado(null);
        } else {
            questionario.temas = temas;
            handleUpdateDiagnostico(questionario)
        }
    }
    
    const onSelectTema = (tema) => {
        setTemaSelecionado(tema);
        const listaDePerguntas = [];
        tema.subTemas.forEach(subTema => {
            subTema.perguntas.forEach((pergunta, index) => {
                listaDePerguntas.push({
                    ...pergunta,
                    descSubtemaDiagnostico: subTema.descSubtemaDiagnostico,
                    codSubtemaDiagnostico: subTema.codSubtemaDiagnostico
                });
            });
        });
        listaDePerguntas.sort((a, b) => a.ordenacao - b.ordenacao)
        setPerguntas(listaDePerguntas);
    }
    
    const carregarQuestionario = async () => {
        DiagnosticoService.find(diagnostico?.id)
            .then(response => {
                if (!response) {
                    throw Error('Questionario vazio');
                }
                setQuestionario(response)
            })
            .catch(() => {
                handleModalStatus({
                    type: "error",
                    onCloseModal: handleGoHome,
                    msgOnError:
                        "Não é possível editar esse diagnóstico no momento.",
                    showModal,
                })
            })
    }
    
    const renderLevelHasExists = (item) => {
        const ordenarNiveis = (niveis) => {
            const ordemDesejada = ["Básico", "Intermediário", "Avançado"];
            niveis.sort((a, b) => {
                return ordemDesejada.indexOf(a.nome) - ordemDesejada.indexOf(b.nome);
            });
            return niveis;
        }
        
        return ordenarNiveis(item.niveis)?.map((nivel) => {
            return (
                <div style={{
                    display: 'flex',
                    flexDirection: 'row',
                    marginBottom: '20px'
                }}>
                    {handleLabelLevel(nivel.nome)}
                    <EditorText  width={'90%'}
                                 onChange={(value => nivel.descricao = value)}
                                 height={'6rem'}
                                 notRequired={true}
                                 showMaxLengthLabel={true}
                                 value={nivel?.descricao}
                                 maxLength={2000}/>
                    
                    {/*<TextAreaInput*/}
                    {/*    width={'90%'}*/}
                    {/*    onChange={(value => nivel.descricao = value)}*/}
                    {/*    height={'6rem'}*/}
                    {/*    notRequired={true}*/}
                    {/*    showMaxLengthLabel={true}*/}
                    {/*    value={nivel?.descricao}*/}
                    {/*    maxLength={2000}/>*/}
                </div>
            )
        })
    }
    
    const renderLevelHasNotExists = (item) => {
        item.niveis = [
            {id: null, nome: "Básico", descricao: null},
            {id: null, nome: "Intermediário", descricao: null},
            {id: null, nome: "Avançado", descricao: null}
        ];
        const ordenarNiveis = (niveis) => {
            const ordemDesejada = ["Básico", "Intermediário", "Avançado"];
            niveis.sort((a, b) => {
                return ordemDesejada.indexOf(a) - ordemDesejada.indexOf(b);
            });
            return niveis;
        }

        return ordenarNiveis(item?.niveis)?.map((nivel) => (
                <div style={{
                    display: 'flex',
                    flexDirection: 'row'
                }}>
                    {handleLabelLevel(nivel.nome)}
                    <EditorText
                        onChange={(value => nivel.descricao = value)}
                        height={'6rem'}
                        notRequired={true}
                        showMaxLengthLabel={true}
                        value={nivel?.descricao}
                        maxLength={2000}/>
                    
                    <TextAreaInput
                        onChange={(value => nivel.descricao = value)}
                        height={'6rem'}
                        notRequired={true}
                        showMaxLengthLabel={true}
                        value={nivel?.descricao}
                        maxLength={2000}/>
                </div>
            )
        )
    }
    
    
    const renderOrderTemas = () => {
        
        return (
            <DragDropContext onDragEnd={onDragEndTema}>
                <Droppable droppableId="table">
                    {(provided) => (
                        <div className={styles.backgroundDrag} {...provided.droppableProps}
                             ref={provided.innerRef} style={{
                            padding: '20px',
                            borderRadius: '20px'
                        }}>
                            <div className={styles.headerContent}>
                                <p className={styles.first}>
                                    Ordem
                                </p>
                                <p className={styles.second}>
                                    Temas
                                </p>
                            </div>
                            {temas.map((item, index) => {
                                return (
                                    <Draggable key={item.ordenacaoTema} draggableId={item.ordenacaoTema.toString()}
                                               index={index}>
                                        {(providedDragabble) => (
                                            <div
                                                className={styles.containerDraggable}
                                                ref={providedDragabble.innerRef}
                                                {...providedDragabble.draggableProps}
                                                {...providedDragabble.dragHandleProps}
                                            >
                                                <p className={styles.id}
                                                   style={{color: '#0061C6'}}>{item?.ordenacaoTema}</p>
                                                <p className={styles.title}>
                                                    <p style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        flexDirection: 'row',
                                                    }}>
                                                        <BaSeIcon
                                                            name={expanded.includes(item.id) ? 'angle-up' : 'angle-down'}
                                                            color='#0061C6'
                                                            size={24}
                                                            description="Botão de ordenação"
                                                            onClick={() => handleExpand(item.id)}
                                                        />
                                                        <span
                                                            onClick={() => onSelectTema(item)}>{item?.descAreaTematicaDiagnostico}</span>
                                                    </p>
                                                    {
                                                        expanded.includes(item.id) &&
                                                        <div style={{
                                                            paddingLeft: '38px',
                                                            paddingTop: '20px',
                                                        }}>
                                                            {
                                                                item?.niveis?.length
                                                                    ? renderLevelHasExists(item)
                                                                    : renderLevelHasNotExists(item)
                                                            }
                                                        </div>
                                                    }
                                                </p>
                                            </div>
                                        )}
                                    </Draggable>
                                )
                            })}
                        </div>
                    )}
                </Droppable>
            </DragDropContext>
        )
    }
    
    
    const renderOrderPerguntas = () => {
        return (
            <DragDropContext onDragEnd={onDragEndPerguntas}>
                <Droppable droppableId="table">
                    {(provided) => (
                        <div className={styles.backgroundDrag} {...provided.droppableProps}
                             ref={provided.innerRef} style={{
                            padding: '20px',
                            borderRadius: '20px'
                        }}>
                            <div className={styles.headerContent} style={{}}>
                                <p style={{width: ''}}>
                                    Ordem
                                </p>
                                <p style={{width: '65%'}}>
                                    Pergunta
                                </p>
                                <p style={{width: '8%'}}>
                                    Tema
                                </p>
                                <p style={{width: '14%'}}>
                                    Subtema
                                </p>
                            </div>
                            {perguntas.map((item, index) => {
                                return (
                                    <Draggable key={item.ordenacao} draggableId={item.ordenacao.toString()}
                                               index={index}>
                                        {(providedDragabble) => (
                                            <div
                                                className={styles.containerDraggable}
                                                ref={providedDragabble.innerRef}
                                                {...providedDragabble.draggableProps}
                                                {...providedDragabble.dragHandleProps}
                                            >
                                                <p style={{color: '#0061C6', width: '', fontWeight: 'bold'}}>{index + 1}</p>
                                                <p style={{width: '65%'}}>
                                                    <div
                                                        style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                                                        <BaSeIcon
                                                            name={expanded.includes(item.id) ? 'angle-up' : 'angle-down'}
                                                            color='#0061C6'
                                                            size={24}
                                                            description="Botão de ordenação"
                                                            onClick={() => handleExpand(item.id)}
                                                        /> {item.diagnosticoPerguntaDescricao}
                                                    </div>
                                                    {expanded.includes(item.id) &&
                                                    <div style={{
                                                        paddingLeft: '38px',
                                                        paddingTop: '20px'
                                                    }}>
                                                        {
                                                            item?.respostas?.sort((a, b) => a.ordenacao - b.ordenacao)
                                                                ?.map(resposta => (
                                                                        <p style={{
                                                                            color: '#646363',
                                                                            fontSize: '14px',
                                                                            lineHeight: '40px'
                                                                        }}>
                                                                            {resposta.diagnosticoPerguntaRespostaDescricao}
                                                                        </p>
                                                                    )
                                                                )
                                                        }
                                                    </div>
                                                    }
                                                </p>
                                                <p style={{width: '8%'}}>{temaSelecionado.descAreaTematicaDiagnostico}</p>
                                                <p style={{width: '15%'}}>{item.descSubtemaDiagnostico}</p>
                                            </div>
                                        )}
                                    </Draggable>
                                )
                            })}
                        </div>
                    )}
                </Droppable>
            </DragDropContext>
        )
    }
    
    const onDragEndTema = (result) => {
        if (!result.destination) {
            return;
        }
        const novosItens = [...temas];
        const [itemArrastado] = novosItens.splice(result.source.index, 1);
        novosItens.splice(result.destination.index, 0, itemArrastado);
        
        novosItens.forEach((item, index) => {
            item.ordenacaoTema = index + 1;
        });
        
        setTemas(novosItens);
    }
    
    const onDragEndPerguntas = (result) => {
        if (!result.destination) {
            return;
        }
        const {source, destination} = result;
        
        const items = Array.from(perguntas);
        const [reorderedItem] = items.splice(source.index, 1);
        items.splice(destination.index, 0, reorderedItem);
        const newItems = items.map((item, index) => {
            return {...item, ordenacao: index + 1};
        });
        setPerguntas(newItems);
    }
    
    
    useEffect(() => {
        if (questionario) {
            const temas = [...questionario?.temas]
            temas.sort((a, b) => a.ordenacaoTema - b.ordenacaoTema)
            setTemas(temas);
            setIsLoading(false);
        }
        // https://github.com/facebook/create-react-app/issues/6880
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [questionario])
    
    
    useEffect(() => {
        carregarQuestionario()
        // https://github.com/facebook/create-react-app/issues/6880
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    
    return (
        <>
            <MainContent>
                <SubTitle>
                    <>
                        <h3>Diagnóstico: ordenar perguntas</h3>
                    </>
                </SubTitle>
                
                <Grid item container md columnSpacing={2}>
                    <Grid item md container spacing={2}>
                        <Grid item md={3}>
                            <Input
                                label={'Nome do diagnóstico'}
                                value={questionario?.nome}
                                disabled={true}
                            />
                        </Grid>
                        
                        {!!temaSelecionado &&
                        <Grid item md={3}>
                            <Input
                                label={'Tema'}
                                value={temaSelecionado?.descAreaTematicaDiagnostico}
                                disabled={true}
                            />
                        </Grid>
                        }
                    </Grid>
                    
                    <Grid item>
                        <Button href="#" onClick={save}>
                            Salvar
                        </Button>
                    </Grid>
                </Grid>
                
                {isLoading
                    ? (
                        <Grid container item alignItems={"center"} justifyContent={'center'}>
                            <div style={{
                                display: 'flex',
                                justifyContent: 'center',
                                flexDirection: 'column',
                                alignItems: 'center',
                            }}>
                                <Spinner radius={80} color={'#0061C6'} stroke={2} visible={true}/>
                                <p>Carregando...</p>
                            </div>
                        </Grid>
                    ) : (
                        !!temaSelecionado ? renderOrderPerguntas() : renderOrderTemas()
                    )}
            
            </MainContent>
            {manageItem?.diagnostico?.id && <UserActionsContent data={manageItem?.diagnostico}/>}
        </>
    )
}
